__turbopack_context__.v({
  "blogContainer": "BlogPage-module-scss-module__mQR91G__blogContainer",
  "blogContents": "BlogPage-module-scss-module__mQR91G__blogContents",
  "blogFooter": "BlogPage-module-scss-module__mQR91G__blogFooter",
  "blogPage": "BlogPage-module-scss-module__mQR91G__blogPage",
  "field": "BlogPage-module-scss-module__mQR91G__field",
  "link": "BlogPage-module-scss-module__mQR91G__link",
  "metadataList": "BlogPage-module-scss-module__mQR91G__metadataList",
  "title": "BlogPage-module-scss-module__mQR91G__title",
});
